import { gql } from '@apollo/client'

import { ClusterDocSnippet } from '../cluster-doc-snippet/cluster-doc-snippet'

export const ClusterDocResultsFragments = {
  haystackItem: gql`
    fragment ClusterDocResults_haystackItem on HaystackItem {
      ...ClusterDocSnippet_haystackItem
    }
    ${ClusterDocSnippet.fragments.haystackItem}
  `,
}
